import {Injectable} from '@angular/core';
// import {Http,Request,RequestOptionsArgs,Response,ConnectionBackend,RequestOptions,Headers} from '@angular/http';
import { Observable } from 'rxjs';

import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { TokenStorage } from 'providers/TokenStorage';


export const JWT_RESPONSE_HEADER: string = 'ludyaccountToken';

@Injectable()
export class AuthHttp implements HttpInterceptor {
  constructor(private tokenStorage: TokenStorage) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Get token
    let token: any;
    if ( this.tokenStorage.getToken() ) {
      token = this.tokenStorage.getToken();
    } else if ( this.tokenStorage.getCookie() ) {
      token = this.tokenStorage.getCookie();
    }

    // Get the auth header from your auth service.
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token} LudyAccount`
    });
    // let headers = req.headers.set('Authorization', `Bearer ${token}`);
    const authReq = req.clone({ headers:  headers});
    return next.handle(authReq);
  }
}
